<section id="content">
	<div class="spinner-container">
		<div class="spinner">
			<div class="sk-folding-cube">
				<div class="sk-cube1 sk-cube"></div>
				<div class="sk-cube2 sk-cube"></div>
				<div class="sk-cube4 sk-cube"></div>
				<div class="sk-cube3 sk-cube"></div>
			</div>
		</div>
	</div>
	<div class="form-group">
		<div class="card">

			<div class="cont">
				<div class="group">
					<div class="collapse-title">User Profile</div>
					<div class="" id="">
						<div class="group-cont">
							<div class="">
								<table class="table editable" id="userprofile-table">
									<thead>
										<span id="selectedregion" hidden>ALL</span>
										<span id="selectedsector" hidden>ALL</span>
									</thead>
									<tbody>
										<div class="form-group">
											<div class="row">
												<div class="col-md-6 col-xs-12">
													<div class="inputs">
														<input type="text" id="empId" readonly="readonly"
															[(ngModel)]="currentLoggedUser.empId" />
														<label for="empId">Emp Id</label>

													</div>
												</div>
												<div class="col-md-6 col-xs-12">
													<div class="inputs">
														<input type="text" id="email" readonly="readonly"
															[(ngModel)]="currentLoggedUser.email" />
														<label for="email">Email</label>
													</div>
												</div>
											</div>
										</div>

										<!-- 2nd Row -->
										<div class="form-group">
											<div class="row">
												<div class="col-md-6 col-xs-12">
													<div class="inputs">
														<input type="text" id="firstName" readonly="readonly"
															[(ngModel)]="currentLoggedUser.firstName" />
														<label for="firstName">First Name</label>

													</div>
												</div>
												<div class="col-md-6 col-xs-12">
													<div class="inputs">
														<input type="text" id="lastName" readonly="readonly"
															[(ngModel)]="currentLoggedUser.lastName" />
														<label for="lastName">Last Name</label>
													</div>
												</div>
											</div>
										</div>
										<!-- 3rd Row -->
										<div class="form-group">
											<div class="row">
												<div class="col-md-6 col-xs-12">
													<div class="inputs">
														<input type="text" id="quota" readonly="readonly"
															[(ngModel)]="currentLoggedUser.quota" />
														<label for="quota">Quota</label>

													</div>
												</div>
												<div class="col-md-6 col-xs-12">
													<div class="inputs">
														<input type="text" id="role" readonly="readonly"
															[(ngModel)]="currentLoggedUser.role.userRole" />
														<label for="role">Role</label>
													</div>
												</div>
											</div>
										</div>
										<!-- 4th Row -->
										<div class="form-group">
											<div class="row">
												<div class="col-md-6 col-xs-12">
													<div class="inputs">
														<input type="text" id="manager" readonly="readonly"
															[(ngModel)]="manager" />
														<label for="manager">Manager</label>
													</div>
												</div>
												<div class="col-md-6 col-xs-12">
													<label for="receiveNotification" class="notification">Receive
														Notification</label>
													<div class="input-container">
														<p-selectButton [options]="buttontypes"
															[(ngModel)]="selectedType"
															(onChange)="onEmailActionChange($event.value)"
															class="notification-toggle">
														</p-selectButton>
													</div>
												</div>
											</div>
										</div>
										<div class="form-group">
										<div class="row">
											<div class="col-md-6 col-xs-12">
											  <div class="inputs">
												<button 
												  pButton 
												  label="Reset Password" 
												  icon="pi pi-key" 
												  class="p-button-outlined" 
												  [routerLink]="['/reset-password']">
												</button>
											  </div>
											</div>
										  </div>
										</div>

										<!-- 5th Row -->
										<div  id="PermissionGroup" class="group hidden">
											<div class="collapse-title" (click)="elem.class = elem.class === 'showChildren' ? '' : 'showChildren'">
												Permissions
												<i class="collapse-icon fa" [ngClass]="elem.class !== 'showChildren' ? 'fa-plus' : 'fa-minus'"></i>
											</div>
											<div class="collapse in show" [ngClass]="{ hideChildren: elem.class !== 'showChildren' }" #elem>
												<div class="group-cont">
													<div class="table-responsive">
														<table width="100%" class="table editable" id="userRule-table">
															<thead>
																<tr>
																	<th class="lob">Lob</th>
																	<th class="sector">Sector</th>
																	<th class="region">Region</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let item of userPermissionList; let i = index">
																	<td><input type="text" [value]="item?.lob" class="disabled"></td>
																	<td><input type="text" [value]="item?.sector?.sector" class="disabled"></td>
																	<td><input type="text" [value]="item?.region?.region" class="disabled"></td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
										

										<div *ngIf="salesUsers.length != 0"  id="userMgmtGroup" class="group hidden">
											<div class="collapse-title"
												(click)="ele.class = ele.class == 'showChildren' ? '' :  'showChildren'">
												Users Reporting
												<i class="collapse-icon fa"
													[ngClass]=" ele.class !== 'showChildren' ? 'fa-plus' : 'fa-minus'"></i>
											</div>
											<div class="collapse in show" id="userManagementGroup"
												[ngClass]="{ hideChildren : ele.class !== 'showChildren' }" #ele>
												<div class="group-cont">
													<div class="table-responsive">

														<p-table #dt class="table" styleClass="ui-table-customers"
															[value]="salesUsers" totalRecords="{{salesUsers.length}}"
															[rows]="10" [showCurrentPageReport]="true"
															[rowsPerPageOptions]="[10,25,50]" [paginator]="true"
															currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

															<ng-template pTemplate="header">
																<tr>
																	<th pSortableColumn="empId">Emp Id<p-sortIcon
																			field="empId"></p-sortIcon></th>
																	<th pSortableColumn="firstName">First
																		Name<p-sortIcon field="firstName"></p-sortIcon>
																	</th>
																	<th pSortableColumn="lastName">Last Name<p-sortIcon
																			field="lastName"></p-sortIcon></th>
																	<th pSortableColumn="email">Email<p-sortIcon
																			field="email"></p-sortIcon></th>
																	<th pSortableColumn="manager">Manager<p-sortIcon
																			field="manager"></p-sortIcon></th>
																	<th pSortableColumn="quota">Quota<p-sortIcon
																			field="quota"></p-sortIcon></th>
																	<th pSortableColumn="role.userRole">Role<p-sortIcon
																			field="role.userRole"></p-sortIcon></th>
																</tr>
															</ng-template>
															<ng-template pTemplate="body" let-user>
																<tr>
																	<td>{{user.empId}}</td>
																	<td>{{user.firstName}}</td>
																	<td>{{user.lastName}}</td>
																	<td>{{user.email}}</td>
																	<td>{{user.manager}}</td>
																	<td>{{user.quota}}</td>
																	<td>{{user.role.userRole}}</td>
																</tr>
															</ng-template>
														</p-table>


													</div>
												</div>
												<!-- /.group-cont -->
											</div>
											<!-- </div> -->
										</div>
									</tbody>
								</table>
							</div>
						</div>
						<!-- /.group-cont -->
					</div>
				</div>
			</div>
		</div>
	</div>
</section>